import React, { useEffect } from 'react';
import { useAlertesPartagees, useNotificationsPartagees } from '../context/NotificationsContext';
import { onNotificationCountUpdate } from '../utils/notificationEvents';

interface NotificationBadgeProps {
  onClick: () => void;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({ onClick }) => {
  // Source partagée : le panneau lit exactement les mêmes données.
  const { unreadCount: notifUnread, refetch: refetchNotif } = useNotificationsPartagees();
  const { unreadCount: alertUnread, refetch: refetchAlert } = useAlertesPartagees();

  // Écouter les mises à jour de compteur et refetch
  useEffect(() => {
    const cleanup = onNotificationCountUpdate(() => {
      refetchNotif();
      refetchAlert();
    });
    return cleanup;
  }, [refetchNotif, refetchAlert]);

  const totalCount = (notifUnread || 0) + (alertUnread || 0);

  return (
    <button onClick={onClick} className="btn btn-ghost btn-circle">
      <div className="indicator">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
        {totalCount > 0 && (
          <span className="badge badge-warning badge-sm indicator-item">
            {totalCount}
          </span>
        )}
      </div>
    </button>
  );
};

export default NotificationBadge;
